import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import database from "../config/firebaseConfig";
import "./styles/Product.css";
import WebsiteFooter from "../components/WebsiteFooter";
import Card2 from "../components/Card2";

const Product = ({ addToCart, productsData, loggedInUser, products }) => {
  const [product, setProduct] = useState({});
  const { productName } = useParams();
  const [productDetails, setProductDetails] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [items, setItems] = useState([]);
  const [newReview, setNewReview] = useState("");
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(5);
  const [averageRating, setAverageRating] = useState(0);
  const [totalReviews, setTotalReviews] = useState(0);
  const [selectedImage, setSelectedImage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        if (!productsData || productsData.length === 0) return;
        const productDetail = productsData.filter((product) => product.Name === productName)[0];
        setProductDetails(productDetail);
        setSelectedImage(productDetail?.Img[0] || ""); // Set the first image as the selected image
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };

    fetchProductDetails();
  }, [productName, productsData, setProductDetails]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!productDetails || !productDetails.Category || !productsData || productsData.length === 0) {
          return;
        }

        const filteredItems = productsData.filter(
          (item) => item.Category === productDetails.Category
        );

        setItems(filteredItems);
      } catch (error) {
        console.error("Error fetching collection data:", error);
      }
    };

    fetchData();
  }, [productsData, productDetails]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const snapshot = await database.ref("Products").once("value");
        if (snapshot.exists()) {
          const productList = snapshot.val();
          const productMap = {};
          Object.values(productList).forEach((product) => {
            productMap[product.Name] = product;
          });
          setProduct(productMap);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleQuantityChange = (type) => {
    setQuantity((prev) => (type === "increase" ? prev + 1 : Math.max(1, prev - 1)));
  };

  const handleAddToCart = () => {
    if (productDetails) {
      addToCart({ name: productName, ...productDetails }, quantity);
    }
  };

  const handleBuyNow = () => {
    if (productDetails) {
      addToCart({ name: productName, ...productDetails }, quantity);
      navigate('/Cart');
    }
  };

  const handleReviewSubmit = async () => {
    if (!newReview.trim() || rating === 0) return;

    if (!loggedInUser) {
      alert("You must be logged in to leave a review.");
      return;
    }

    try {
      const customerSnapshot = await database.ref(`Customers/${loggedInUser}`).once("value");
      const customer = customerSnapshot.val();

      let customerName = "Anonymous User";
      if (customer && customer.deliveryDetails?.email === loggedInUser.email) {
        customerName = customer.deliveryDetails.fullName;
      }

      const reviewData = {
        review: newReview,
        rating,
        reviewBy: loggedInUser,
        reviewByName: customerName,
        timestamp: new Date().toISOString(),
      };

      const newReviewRef = database.ref(`Reviews/${productName}`).push();
      await newReviewRef.set(reviewData);

      setNewReview("");
      setRating(0);

    } catch (error) {
      console.error("Error submitting review:", error);
      alert("Failed to submit review. Please try again.");
    }
  };

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const updatedReviewsSnapshot = await database.ref(`Reviews/${productName}`).once("value");
        const updatedReviewsData = updatedReviewsSnapshot.val();
        const updatedReviews = updatedReviewsData ? Object.values(updatedReviewsData) : [];

        setReviews(updatedReviews);

        if (updatedReviews.length > 0) {
          const totalStars = updatedReviews.reduce((sum, review) => sum + review.rating, 0);
          setAverageRating((totalStars / updatedReviews.length).toFixed(1));
        } else {
          setAverageRating(0);
        }
        setTotalReviews(updatedReviews.length);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    fetchReviews();
  }, [productName]);

  if (!productDetails) {
    return <p>Loading product details...</p>;
  }

  return (
    <>
      <div className="product-container">
        <div className="product-image">
          {productDetails.isCombo ? (
            <div className="product-combo-grid">
              {Array.isArray(productDetails.Products) &&
                productDetails.Products.map((productName, i) => {
                  const productref = product[productName];
                  return (
                    <img
                      key={i}
                      src={productref?.Img?.[0] || "/placeholder.jpg"}
                      alt={productref?.Name || "Unknown Product"}
                      className="combo-image"
                      style={{ width: "100px", height: "100px" }}
                    />
                  );
                })}
            </div>
          ) : (
            <>
              <img src={selectedImage} alt={productName} className="main-product-image" style={{ width: "300px", height: "275px" }} />
              <div className="thumbnail-container">
                {productDetails.Img.map((imgSrc, index) => (
                  <img
                    key={index}
                    src={imgSrc}
                    alt={productName}
                    className="thumbnail-image"
                    onClick={() => setSelectedImage(imgSrc)}
                   style={{ width: "50px", height: "50px" }}
                  />
                ))}
              </div>
            </>
          )}
        </div>
        <div className="product-details">
          <h1>{productName}</h1>
          <p>
            <span style={{ color: "gold" }}>{averageRating} ★</span> | {totalReviews} Reviews
          </p>

          <p className="product-category">{productDetails.Category}</p>
          <p className="product-description">{productDetails.Desc}</p>
          {(productDetails.Station || productDetails.Station_Code) && (
            <div>
              <span>Station:</span>
              <strong>{productDetails.Station} {productDetails.Station_Code}</strong>
            </div>
          )}

          <div className="price-list">
            {productDetails.Net_Wt} {productDetails.Net_Wt_Unit} | Rs. {productDetails.Price}
          </div>
          {quantity > 1 && <div className="price-list">
            For {quantity}: {productDetails.Net_Wt * quantity} {productDetails.Net_Wt_Unit} | Rs. {productDetails.Price * quantity}
          </div>}

          <div className="quantity-selector">
            <button onClick={() => handleQuantityChange("decrease")}>-</button>
            <span className="quantity-display">{quantity}</span>
            <button onClick={() => handleQuantityChange("increase")}>+</button>
          </div>

          <div className="product-actions">
            <button className="add-to-cart-button" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <button
              className="buy-now-button"
              onClick={() => handleBuyNow()}
            >
              Buy Now
            </button>
          </div>
        </div>
        <div className="product-info">
          <h1>Details</h1>

          {productDetails.Best_Before && (
            <div><span>Best Before:</span><strong>{productDetails.Best_Before}</strong></div>
          )}

          {productDetails.Ingredients && (
            <div><span>Ingredients:</span><strong>{productDetails.Ingredients}</strong></div>
          )}

          {productDetails.Category && (
            <div><span>Category:</span><strong>{productDetails.Category}</strong></div>
          )}

          {(productDetails.Station || productDetails.Station_Code) && (
            <div>
              <span>Station:</span>
              <strong>{productDetails.Station} {productDetails.Station_Code}</strong>
            </div>
          )}

          {(productDetails.City || productDetails.State) && (
            <div>
              <span>Origin:</span>
              <strong>{productDetails.City}{productDetails.City && productDetails.State ? ', ' : ''}{productDetails.State}</strong>
            </div>
          )}

          {(productDetails.Net_Wt && productDetails.Net_Wt_Unit) && (
            <div>
              <span>Net Weight:</span>
              <strong>{productDetails.Net_Wt} {productDetails.Net_Wt_Unit}</strong>
            </div>
          )}

          {quantity > 1 && productDetails.Net_Wt && productDetails.Net_Wt_Unit && productDetails.Price && (
            <div>
              For {quantity}: {productDetails.Net_Wt * quantity} {productDetails.Net_Wt_Unit} | Rs. {productDetails.Price * quantity}
            </div>
          )}
        </div>

        <div className="reviews-section">
          <h2>Reviews</h2>
          {reviews.length > 0 ? (
            reviews.map((review, index) => (
              <div key={index} className="review-item">
                <p>{review.review}</p>
                <div className="review-author">
                  <strong>{review.reviewByName}</strong>
                </div>
                <p className="review-rating" style={{ cursor: "pointer", fontSize: "24px", color: "gold" }} >{"★".repeat(review.rating)}</p>
              </div>
            ))
          ) : (
            <p style={{ fontWeight: 500, fontSize: '15px' }}>No reviews yet. Be the first to leave one!</p>
          )}

          <div className="review-box">
            <div className="rating-input">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  onClick={() => setRating(star)}
                  style={{ cursor: "pointer", fontSize: "20px", color: star <= rating ? "gold" : "gray" }}
                >
                  ★
                </span>
              ))}
            </div>
            <textarea
              value={newReview}
              onChange={(e) => setNewReview(e.target.value)}
              placeholder="Write a review..."
            />
            <button onClick={handleReviewSubmit}>Submit Review</button>
          </div>
        </div>

        <div className="more-products">
          <div style={{ width: "100vw", padding: '15px 15px 0px 15px', fontWeight: 700, fontSize: '24px', textAlign: 'center' }}>More Like This</div>
          {items.length > 0 ? (
            items.map((item, index) => (
              <Card2 key={index} item={item} onClick={() => handleNavigation(`/Product/${item.Name}`)} products={products}/>
            ))
          ) : (
            <p>No items available for this category</p>
          )}
        </div>
      </div>
      <WebsiteFooter />
    </>
  );
};

export default Product;


